import React from 'react';

const BlogCard = ({ data }) => {
    const { img, author, title } = data;
    return (
        <div className="col-lg-3 col-md-4">
            <article className="blog_post">
                <div className="post_img">
                    <img src={img} alt="blog" />
                    <div className="calendar">
                        <a>Aug <br />
                            <span className="date">06</span></a>
                    </div>
                </div>
                <div className="post_content">
                    <div className="post_header">
                        <div className="metalist">
                            <span className="author"
                            ><a>{author}</a></span
                            >
                        </div>
                        <h3 className="post_title">
                            <a href="/blog-details">{title}</a>
                        </h3>
                    </div>
                    <div className="post_intro">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur mod tempor
                            indidunt ut labore et dolore magna aliqua. Ut enim ad...
                        </p>
                    </div>
                    <div className="post_footer">
                        <div className="read_more">
                            <a href="/blog-details">See More</a>
                        </div>
                    </div>
                </div>
            </article>
        </div>
    );
};

export default BlogCard;